import { CurrencyBlockchain } from './CurrencyBlockchain';

export class Currency {
  idCurrency: number;
  code: string;
  name: string | null;
  description: string | null;
  locked: boolean;
  blockchains: CurrencyBlockchain[];

  constructor(
    idCurrency: number,
    code: string,
    name: string | null,
    description: string | null,
    locked: boolean,
    blockchains: CurrencyBlockchain[] = [],
  ) {
    this.idCurrency = idCurrency;
    this.code = code;
    this.name = name;
    this.description = description;
    this.locked = locked;
    this.blockchains = blockchains;
  }

  static fromRaw(raw: any): Currency {
    return new Currency(
      raw.idCurrency,
      String(raw.code),
      raw.name === null ? null : String(raw.name),
      raw.description === null ? null : String(raw.description),
      Boolean(raw.locked),
      raw.blockchains ? raw.blockchains.map((currencyBlockchain: any) => CurrencyBlockchain.fromRaw(currencyBlockchain)) : [],
    );
  }

  clone(): Currency {
    return new Currency(
      this.idCurrency,
      this.code,
      this.name,
      this.description,
      this.locked,
      this.blockchains.map((currencyBlockchain) => currencyBlockchain.clone()),
    );
  }

  toPayload(): any {
    const payload: any = {
      code: this.code,
      name: this.name,
      description: this.description,
    };
    if (this.idCurrency !== 0) {
      payload.idCurrency = this.idCurrency;
    }
    return payload;
  }
}
